<template>
  <div class="d-flex align-items-center">
    <div class="display-6"><slot /></div>
    <div class="flex-grow-1 border-bottom border-2 ms-3 pt-2"></div>
  </div>
</template>
<script lang="ts" setup></script>
